import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import { bindActionCreators } from "redux";
import DialogContent from "@material-ui/core/DialogContent";
import { Field, formValueSelector, reduxForm } from "redux-form";
import { RenderInput } from "../InputComponents/Inputs.jsx";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "underscore";
import * as assayActions from "../../../actions/assays";
import { minLength5 } from "../../../util/validations";

class NameModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  componentDidMount() {
    const { openModal } = this.props;
    this.setState({ open: openModal });
  }

  handleClose = () => {
    this.setState({ open: false });
    this.props.closeModal();
  };

  onSubmit = (values) => {
    const { assayCommercialId, actions } = this.props;
    const { assayName } = values;
    this.handleClose();
    actions.setAssayName({ assayCommercialId, assayName });
    actions.addToMyAssay(assayCommercialId);
  };

  render() {
    const { open } = this.state;
    const { handleSubmit, pristine, submitting } = this.props;
    return (
      <Dialog open={open}>
        <DialogContent>
          <div className="row">
            <div className="col">
              <Field
                name="assayName"
                className="form-control"
                component={RenderInput}
                label="Enter Assay Name:"
                validate={minLength5}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions className="d-flex align-items-center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(this.onSubmit.bind(this))}
            className="btn btn-block"
          >
            Submit
          </Button>
          <Button
            variant="contained"
            className="btn btn-block"
            style={{ marginTop: "0" }}
            onClick={this.handleClose}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const stateToProps = (state, props) => ({
  initialValues: {
    assayName: props.assayName || "",
  },
});

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(assayActions, dispatch),
});

NameModal = reduxForm({
  form: "frmModalAssayName",
})(NameModal);

NameModal = connect(stateToProps, dispatchToProps)(NameModal);

export default NameModal;
